export const weekDayConstants = [
  { name: "Sunday", value: 1 },
  { name: "Monday", value: 2 },
  { name: "Tuesday", value: 3 },
  { name: "Wednesday", value: 4 },
  { name: "Thursday", value: 5 },
  { name: "Friday", value: 6 },
  { name: "Saturday", value: 7 },
];
